import { httpsCallable } from 'firebase/functions';
import type { DeckIntelligence } from '../types';
import { functions } from './firebase';

export type AnalyzeInvestmentCaseResponse = {
  deckIntelligence: DeckIntelligence;
};

export function analyzeInvestmentCaseErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Add at least 200 characters of deck OCR text before analyzing.';
    }
    if (code === 'functions/not-found') {
      return 'Investment case not found.';
    }
    if (code === 'functions/permission-denied') {
      return 'You do not have permission to analyze this case.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to analyze the deck.';
    }
    if (code === 'functions/unavailable') {
      return 'Analysis service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Analysis failed. Try again or check deck text.';
    }
  }
  return err instanceof Error ? err.message : 'Deck analysis failed.';
}

export async function analyzeInvestmentCase(caseId: string): Promise<DeckIntelligence> {
  const fn = httpsCallable<{ caseId: string }, AnalyzeInvestmentCaseResponse>(
    functions,
    'analyzeInvestmentCase'
  );
  const result = await fn({ caseId: caseId.trim() });
  return result.data.deckIntelligence;
}
